import { definePreset } from "@unocss/core";
//#region src/index.ts
const remRE = /(-?[.\d]+)rem/g;
/**
* @see https://unocss.dev/presets/rem-to-px
*/
const presetRemToPx = definePreset((options = {}) => {
	const { baseFontSize = 16 } = options;
	return {
		name: "@unocss/preset-rem-to-px",
		postprocess: (util) => {
			util.entries.forEach((i) => {
				const value = i[1];
				if (typeof value === "string" && remRE.test(value)) i[1] = value.replace(remRE, (_, p1) => `${p1 * baseFontSize}px`);
			});
		}
	};
});
//#endregion
export { presetRemToPx as default, presetRemToPx };
